export default __webpack_public_path__ + "static/media/halftone1.38f3edcb.png";